import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import styled from 'styled-components';

import { REQUEST_API_KEY } from 'modules/Api/constants';
import { BrowserRouter as Router, Route, Switch, withRouter, Link, Redirect } from 'react-router-dom';
import { selectIsLoggedIn, selectWork, selectError } from 'modules/Api/selectors';
import { Card } from '../../../components/Card';
import { Loader } from '../../../components/Loader';
import { Button } from '../../../components/Buttons';
import { BaseComponent } from '../../../components/BaseComponent';

import { FormField, FormFields } from '../../../components/FormFields';
import config from '../../../env';
import { VBox } from '../../../components/Box';
import { PageButtons } from '../../../components/Controls/PageButtons';
import { Checkbox } from '../../../components/Checkbox';
import styles from './login.module.css';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';

const Container = styled.div``;

const baseState = {
  email: config.default_login || '',
  password: config.default_pass || '',
  reset_email: '',
  error: null,
  loading: false,
  rememberMe: false,
};

/* eslint-disable react/prefer-stateless-function */
class LoginComp extends BaseComponent {
  constructor(props) {
    super(props, { ...baseState });
  }

  resetSelf() {
    this.setState({ ...baseState });
    this.props.history.push('/');
  }

  submit() {
    this.props.loginSubmit(this.state.email, this.state.password, this.state.rememberMe);
  }

  onInputChange(e) {
    this.updateState(e.target.name, e.target.value);
  }

  onInputKeyPress(event) {
    if (event.key === 'Enter') {
      this.submit();
    }
  }

  render() {
    if (this.props.loading) {
      return <Loader onCard />;
    }

    const error = this.props.loginError;
    const errorType = _.get(error, 'data.error.message', 'default');

    const ALLOW_LOGIN = true;

    const { email, password } = this.state;

    if (this.props.isLoggedIn) {
      return <Redirect to="/" />;
    }

    return (
      <Container className={styles.container}>
        <form>
          <VBox center>
            <Card className={styles.cardLogin}>
            <img className={styles.imageStyles} src="https://www.vindat.nl/wp-content/uploads/2022/04/vindat_logo_black-1.png" /><br /><br />
              {ALLOW_LOGIN ? (
                <>
                  {error ? <div className="well error">{this.lbl(`login.error.${errorType}`)}</div> : ''}

                  <div className={styles.formControl}>
                    <label className="form-label">{this.lbl('login.form.email')}</label>
                    <input
                      className="form-control"
                      onKeyPress={this.onInputKeyPress.bind(this)}
                      autoComplete="email"
                      id="email"
                      type="email"
                      name="email"
                      placeholder="e-mail@address.com"
                      value={email}
                      onChange={this.onInputChange.bind(this)}
                    />
                  </div>

                  <div className={styles.formControl}>
                    <label className="form-label">{this.lbl('login.form.password')}</label>
                    <input
                      onKeyPress={this.onInputKeyPress.bind(this)}
                      className="form-control"
                      autoComplete="current-password"
                      id="password"
                      type="password"
                      name="password"
                      value={password}
                      placeholder="password"
                      onChange={this.onInputChange.bind(this)}
                    />
                  </div>

                  <div className={styles.formControl}>
                    <CheckboxComponent
                      label={this.lbl('login.store.refresh_token')}
                      checked={this.state.rememberMe}
                      onChange={this.setStateFn({
                        rememberMe: !this.state.rememberMe,
                      })}
                    />
                  </div>

                  <div className={styles.forgotLink}>
               

                    {/* <div
                    onClick={() => this.props.history.push('/login/register')}
                  >
                    {this.lbl('register')}
                  </div> */}
                  </div>
                </>
              ) : null}

              <div className="text-center">
                <ButtonComponent style="ButtonSoftPrimarySearch" onClick={this.submit.bind(this)}>
                  {this.lbl('login.button')}
                </ButtonComponent>
              </div>
            </Card>
          </VBox>
        </form>
      </Container>
    );
  }
}

LoginComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    isLoggedIn: selectIsLoggedIn(),
    loginError: selectError(REQUEST_API_KEY),
    loading: selectWork(REQUEST_API_KEY),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    loginSubmit: (email, password, rememberMe) => {
      if (password == 'password') password = '';
      if (password == 'drowssap') password = 'password';
      dispatch({
        type: REQUEST_API_KEY,
        email,
        password,
        rememberMe,
      });
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Login = compose(withRouter, withConnect)(LoginComp);
